// @ts-nocheck
import React, { useState } from 'react';
import { generateClient } from 'aws-amplify/api';
import { useSelector } from 'react-redux';
import { createProcessedModelSchema } from '../graphql/mutations';

const TestProcessedModelSchema = () => {
  const [testResult, setTestResult] = useState('');
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const client = generateClient();

  const testCreateSchema = async () => {
    setLoading(true);
    try {
      const testSchema = {
        id: crypto.randomUUID(),
        name: "Test Wind Farm Schema",
        description: "Test schema created via GraphQL",
        type: "Wind Farm",
        schemaType: "wind-farm-v1",
        version: "1.0",
        executionUrl: "https://test-wind-farm-service.run.app/execute",
        schemaFields: JSON.stringify({
          siteName: "Test Wind Farm",
          latitude: 40.7128,
          longitude: -74.0060,
          totalCapacity: "100 MW"
        }),
        // dataSources will be managed as separate DataSource records
        runSchedule: JSON.stringify({
          frequency: "DAILY",
          timezone: "UTC"
        }),
        isActive: true,
        activeStatus: "ACTIVE",  // "ACTIVE" or "INACTIVE" for GSI querying
        owner: user?.id || "test-user-id",
        cognitoIdentityId: user?.cognitoIdentityId || "test-cognito-id",
        organizationId: user?.organizations?.data?.[0]?.id || "test-org-id",
        s3BasePath: `protected/${user?.cognitoIdentityId || 'test-cognito-id'}/processedModelSchema/${testSchema.id}/`
      };

      console.log('Creating test schema:', testSchema);
      
      const result = await client.graphql({
        query: createProcessedModelSchema,
        variables: { input: testSchema }
      });
      
      setTestResult(`✅ CREATE SUCCESS: ${JSON.stringify(result.data.createProcessedModelSchema, null, 2)}`);
    } catch (error) {
      console.error('Create test failed:', error);
      setTestResult(`❌ CREATE FAILED: ${error.message}\n${JSON.stringify(error, null, 2)}`);
    } finally {
      setLoading(false);
    }
  };

  const testQuerySchemas = async () => {
    setLoading(true);
    try {
      const { listProcessedModelSchemas } = await import('../graphql/queries');

      const result = await client.graphql({
        query: listProcessedModelSchemas
      });

      setTestResult(`✅ QUERY SUCCESS: Found ${result.data.listProcessedModelSchemas.items.length} schemas\n${JSON.stringify(result.data.listProcessedModelSchemas.items, null, 2)}`);
    } catch (error) {
      console.error('Query test failed:', error);
      setTestResult(`❌ QUERY FAILED: ${error.message}\n${JSON.stringify(error, null, 2)}`);
    } finally {
      setLoading(false);
    }
  };

  const testListAll = async () => {
    setLoading(true);
    try {
      const { listProcessedModelSchemas } = await import('../graphql/queries');
      
      const result = await client.graphql({
        query: listProcessedModelSchemas
      });
      
      setTestResult(`✅ LIST ALL SUCCESS: Found ${result.data.listProcessedModelSchemas.items.length} total schemas\n${JSON.stringify(result.data.listProcessedModelSchemas.items, null, 2)}`);
    } catch (error) {
      console.error('List all test failed:', error);
      setTestResult(`❌ LIST ALL FAILED: ${error.message}\n${JSON.stringify(error, null, 2)}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="eai-panel">
      <h3 className="eai-panel-title mb-4">Test ProcessedModelSchema DynamoDB</h3>
      
      <div className="mb-4 flex flex-wrap gap-3">
        <button
          onClick={testCreateSchema}
          disabled={loading}
          className="eai-btn-cta"
        >
          {loading ? 'Testing...' : 'Test CREATE Schema'}
        </button>
        
        <button
          onClick={testQuerySchemas}
          disabled={loading}
          className="eai-btn-outline"
        >
          {loading ? 'Testing...' : 'Test QUERY All Schemas'}
        </button>
        
        <button
          onClick={testListAll}
          disabled={loading}
          className="eai-btn-outline"
        >
          {loading ? 'Testing...' : 'Test LIST All Schemas'}
        </button>
      </div>

      <div className="rounded-md bg-eai-surface-sunken p-4">
        <h4 className="eai-meta-label mb-2 block">Test Results:</h4>
        <pre className="overflow-auto whitespace-pre-wrap font-mono text-eai-body-xs text-eai-ink">
          {testResult || 'Click a test button to see results...'}
        </pre>
      </div>

      <div className="eai-description-sm mt-4">
        <p><strong>User Info:</strong></p>
        <p>Email: {user?.permissionDetails?.email || 'Not logged in'}</p>
        <p>Cognito ID: {user?.cognitoIdentityId || 'Not available'}</p>
        <p>Org ID: {user?.organizations?.data?.[0]?.id || 'Not available'}</p>
      </div>
    </div>
  );
};

export default TestProcessedModelSchema;